import { NotificationChannelEnum, NotificationData, RuleV2 } from '@clients/myTrips' // eslint-disable-line no-unused-vars

export function channelSubtitle (rule: RuleV2 | NotificationData): string {
  if (!rule.active) {
    return 'Inaktiv'
  } else {
    return rule.channels.length > 0 && [...rule.channels]
      .sort().map(c => {
        switch (c) {
          case NotificationChannelEnum.SMS: return 'SMS'
          case NotificationChannelEnum.Email: return 'E-Mail'
          case NotificationChannelEnum.AppPush: return 'Push'
        }
      }).join(', ')
  }
}
